import { mapFields } from 'vuex-map-fields'

export default {
	computed: {
		...mapFields('notification', {
			notification: 'notification',
			errors: 'errors'
		})
	},

	methods: {
		async form () {
			const {
				ageTo,
				ageFrom,
				title,
				description,
				date,
				time,
				country,
				gender,
				users
			} = this.notification

			const { filters } = this.$options
			const timeFormatted = filters.dateFormatter(time, 'HH:mm:ss')
			const dateTime = `${filters.dateFormatter(date, 'YYYY-MM-DD')} ${timeFormatted}`
			const form = new FormData()

			form.append('title', title)
			form.append('description', description)
			form.append('notification_date', dateTime)

			if (users.length) {
				form.append('user_id', users.map(item => item.id).join())
			}

			if (ageFrom) {
				form.append('age_from', ageFrom)

				if (ageTo) {
					form.append('age_to', ageTo)
				} else {
					form.append('age_to', ageFrom)
				}
			}

			if (gender.length) {
				form.append('gender', gender.map(item => item.value).join())
			}

			if (country.length) {
				form.append('country', country.map(item => item.country).join())
			}

			return form
		},

		async validate () {
			const {
				ageTo,
				ageFrom,
				title,
				description,
				date,
				time
			} = this.notification
			const { filters } = this.$options

			this.errors = {
				title: '',
				description: '',
				dateTime: '',
				age: ''
			}

			if (title === '') {
				this.errors.title = 'Title is required.'
				return false
			}

			if (description === '') {
				this.errors.description = 'Description is required.'
				return false
			}

			if (date === '' ||
				time === '') {
				this.errors.dateTime = 'Date and Time is required.'
				return false
			}

			if (date === '' ||
				time === '') {
				this.errors.dateTime = 'Date and Time is required.'
				return false
			}

			const timeFormatted = filters.dateFormatter(time, 'HH:mm:ss')
			const isPostDate = filters.isPostDate(`${filters.dateFormatter(date, 'YYYY-MM-DD')} ${timeFormatted}`)

			if (isPostDate) {
				this.errors.dateTime = 'Invalid date time selection.'
				return false
			}

			if ((ageTo && ageFrom) && ageFrom > ageTo) {
				this.errors.age = 'Age range is invalid.'
				return false
			}

			return true
		},

		throwWarning (message) {
			this.$store.commit('modal/toggleNotification', {
				notificationName: 'notification-banner',
				notificationType: 'warning',
				notificationDesc: message
			})
		}

	}
}
